  function getFocusableElements(container) {
    return Array.from(
      container.querySelectorAll(
        "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
      )
    );
  }
  document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
    summary.setAttribute('role', 'button');
    summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));
    if (summary.nextElementSibling && summary.nextElementSibling.getAttribute('id')) {
      summary.setAttribute('aria-controls', summary.nextElementSibling.id);
    }
    summary.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });
    if (summary.closest('header-drawer')) return;
    summary.parentElement.addEventListener('keyup', onKeyUpEscape);
  });
  document.addEventListener(
    'toggle',
    function onMenuDrawerNestedDetailsToggle(e) {
      const detailsEl = e.target;
      if (!detailsEl || detailsEl.tagName !== 'DETAILS') return;
      if (!detailsEl.open) return;
      const drawer = detailsEl.closest('#menu-drawer');
      if (!drawer) return;
      if (detailsEl.id === 'Details-menu-drawer-container') return;
      const panel = detailsEl.querySelector(':scope > .menu-drawer__submenu .menu-drawer__inner-submenu');
      if (!panel) return;
      const first =
        panel.querySelector(
          'a.yt-nav-image-url[href], a.parent-sub-menu[href], .youthful-submenu-content a[href], .youthful-submenu-container a[href], ul.menu-drawer__menu a[href]'
        ) || panel.querySelector('.menu-drawer__close-button');
      if (!first || typeof first.focus !== 'function') return;
      requestAnimationFrame(function () {
        first.focus({ preventScroll: true });
      });
    },
    true
  );
  const trapFocusHandlers = {};
  function trapFocus(container, elementToFocus = container) {
    removeTrapFocus();
    if (!container) return;
    const focusables = () => getFocusableElements(container);
    const pickFocusTarget = () => {
      if (
        elementToFocus &&
        typeof elementToFocus.focus === 'function' &&
        container.contains(elementToFocus)
      ) {
        return elementToFocus;
      }
      const roots = focusables();
      return roots[0] || container;
    };
    trapFocusHandlers._container = container;
    trapFocusHandlers._onKeydown = function (event) {
      const tab =
        event.key === 'Tab' ||
        (event.code && event.code.toUpperCase() === 'TAB');
      if (!tab) return;
      const roots = focusables();
      if (!roots.length) return;
      const first = roots[0];
      const last = roots[roots.length - 1];
      const active = document.activeElement;
      if (!container.contains(active)) {
        event.preventDefault();
        first.focus();
        return;
      }
      if (event.shiftKey) {
        if (active === first) {
          event.preventDefault();
          last.focus();
        }
      } else if (active === last) {
        event.preventDefault();
        first.focus();
      }
    };
    document.addEventListener('keydown', trapFocusHandlers._onKeydown, true);
    const target = pickFocusTarget();
    if (target && typeof target.focus === 'function') {
      target.focus({ preventScroll: true });
    }
  }
  // Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
  try {
    document.querySelector(":focus-visible");
  } catch (e) {
    focusVisiblePolyfill();
  }
  
  function focusVisiblePolyfill() {
    const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
    let currentFocusedElement = null;
    let mouseClick = null;
    window.addEventListener('keydown', (event) => {
      if (navKeys.includes(event.code.toUpperCase())) {
        mouseClick = false;
      }
    });
    window.addEventListener('mousedown', (event) => {
      mouseClick = true;
    });
    window.addEventListener('focus', () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');
      if (mouseClick) return;
      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    }, true);
  }
  
  function pauseAllMedia() {
    document.querySelectorAll('.js-youtube').forEach((video) => {
      video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
    });
    document.querySelectorAll('.js-vimeo').forEach((video) => {
      video.contentWindow.postMessage('{"method":"pause"}', '*');
    });
    document.querySelectorAll('video').forEach((video) => video.pause());
    document.querySelectorAll('product-model').forEach((model) => {
      if (model.modelViewerUI) model.modelViewerUI.pause();
    });
  }
  
  function removeTrapFocus(elementToFocus = null) {
    if (trapFocusHandlers._onKeydown) {
      document.removeEventListener('keydown', trapFocusHandlers._onKeydown, true);
      trapFocusHandlers._onKeydown = null;
    }
    trapFocusHandlers._container = null;
    if (typeof trapFocusHandlers.focusin === 'function') {
      document.removeEventListener('focusin', trapFocusHandlers.focusin);
    }
    if (typeof trapFocusHandlers.focusout === 'function') {
      document.removeEventListener('focusout', trapFocusHandlers.focusout);
    }
    if (typeof trapFocusHandlers.keydown === 'function') {
      document.removeEventListener('keydown', trapFocusHandlers.keydown);
    }
    trapFocusHandlers.focusin = null;
    trapFocusHandlers.focusout = null;
    trapFocusHandlers.keydown = null;
    if (elementToFocus && typeof elementToFocus.focus === 'function') {
      elementToFocus.focus();
    }
  }

  window.trapFocus = trapFocus;
  window.removeTrapFocus = removeTrapFocus;
  
  function onKeyUpEscape(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;
    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;
    const summaryElement = openDetailsElement.querySelector('summary');
    openDetailsElement.removeAttribute('open');
    summaryElement.setAttribute('aria-expanded', false);
    summaryElement.focus();
  }
  class QuantityInput extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('input');
      this.changeEvent = new Event('change', {
        bubbles: true
      })
      this.querySelectorAll('button').forEach(
        (button) => button.addEventListener('click', this.onButtonClick.bind(this))
      );
    }
    onButtonClick(event) {
      event.preventDefault();
      const previousValue = this.input.value;
      event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
      if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
    }
  }
  customElements.define('quantity-input', QuantityInput);
  function debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
  
  function fetchConfig(type = 'json') {
    return {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': `application/${type}`
      }
    };
  }
  /* Shopify Common JS */
  if ((typeof window.Shopify) == 'undefined') {
    window.Shopify = {};
  }
  Shopify.bind = function(fn, scope) {
    return function() {
      return fn.apply(scope, arguments);
    }
  };
  $(document).keyup(function(e) {
    if (e.key === "Escape") {
      $(".includespopup .popup-close .close, .whats-included-popup .popup-close .close").trigger("click");
      if ($('.modal.fade').hasClass('show')) {
        $('.modal.fade button.close').trigger("click");
      }
    }
  });
  Shopify.setSelectorByValue = function(selector, value) {
    for (var i = 0, count = selector.options.length; i < count; i++) {
      var option = selector.options[i];
      if (value == option.value || value == option.innerHTML) {
        selector.selectedIndex = i;
        return i;
      }
    }
  };
  Shopify.addListener = function(target, eventName, callback) {
    target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on' + eventName, callback);
  };
  Shopify.postLink = function(path, options) {
    options = options || {};
    var method = options['method'] || 'post';
    var params = options['parameters'] || {};
    var form = document.createElement("form");
    form.setAttribute("method", method);
    form.setAttribute("action", path);
    for (var key in params) {
      var hiddenField = document.createElement("input");
      hiddenField.setAttribute("type", "hidden");
      hiddenField.setAttribute("name", key);
      hiddenField.setAttribute("value", params[key]);
      form.appendChild(hiddenField);
    }
    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
  };
  Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
    this.countryEl = document.getElementById(country_domid);
    this.provinceEl = document.getElementById(province_domid);
    this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);
    Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));
    this.initCountry();
    this.initProvince();
  };
  Shopify.CountryProvinceSelector.prototype = {
    initCountry: function() {
      var value = this.countryEl.getAttribute('data-default');
      Shopify.setSelectorByValue(this.countryEl, value);
      this.countryHandler();
    },
    initProvince: function() {
      var value = this.provinceEl.getAttribute('data-default');
      if (value && this.provinceEl.options.length > 0) {
        Shopify.setSelectorByValue(this.provinceEl, value);
      }
    },
    countryHandler: function(e) {
      var opt = this.countryEl.options[this.countryEl.selectedIndex];
      var raw = opt.getAttribute('data-provinces');
      var provinces = JSON.parse(raw);
      this.clearOptions(this.provinceEl);
      if (provinces && provinces.length == 0) {
        this.provinceContainer.style.display = 'none';
      } else {
        for (var i = 0; i < provinces.length; i++) {
          var opt = document.createElement('option');
          opt.value = provinces[i][0];
          opt.innerHTML = provinces[i][1];
          this.provinceEl.appendChild(opt);
        }
        this.provinceContainer.style.display = "";
      }
    },
    clearOptions: function(selector) {
      while (selector.firstChild) {
        selector.removeChild(selector.firstChild);
      }
    },
    setOptions: function(selector, values) {
      for (var i = 0, count = values.length; i < values.length; i++) {
        var opt = document.createElement('option');
        opt.value = values[i];
        opt.innerHTML = values[i];
        selector.appendChild(opt);
      }
    }
  };
  class MenuDrawer extends HTMLElement {
    constructor() {
      super();
      this.mainDetailsToggle = this.querySelector('details');
      this.addEventListener('keyup', this.onKeyUp.bind(this));
      this.addEventListener('focusout', this.onFocusOut.bind(this));
      this.bindEvents();
    }
    bindEvents() {
      this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
      this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
    }
    onKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;
      const openDetailsElement = event.target.closest('details[open]');
      if (!openDetailsElement) return;
      openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
    }
    onSummaryClick(event) {
      const summaryElement = event.currentTarget;
      const detailsElement = summaryElement.parentNode;
      const parentMenuElement = detailsElement.closest('.has-submenu');
      const isOpen = detailsElement.hasAttribute('open');
      const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
  
      function addTrapFocus() {
        const panel = summaryElement.nextElementSibling;
        const firstMenuLink =
          panel &&
          panel.querySelector(
            'ul.menu-drawer__menu a.menu-drawer__menu-item[href], ul.menu-drawer__menu a.link[href]'
          );
        const closeBtn = detailsElement.querySelector('button.menu-drawer__close-button');
        trapFocus(panel, firstMenuLink || closeBtn || detailsElement.querySelector('button'));
        panel && panel.removeEventListener('transitionend', addTrapFocus);
      }
      if (detailsElement === this.mainDetailsToggle) {
        if (isOpen) event.preventDefault();
        isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
        if (window.matchMedia('(max-width: 990px)')) {
          document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
        }
      } else {
        setTimeout(() => {
          detailsElement.classList.add('menu-opening');
          summaryElement.setAttribute('aria-expanded', true);
          parentMenuElement && parentMenuElement.classList.add('submenu-open');
          !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
        }, 100);
      }
    }
    openMenuDrawer(summaryElement) {
      setTimeout(() => {
        this.mainDetailsToggle.classList.add('menu-opening');
      });
      summaryElement.setAttribute('aria-expanded', true);
      trapFocus(this.mainDetailsToggle, summaryElement);
      document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    }
    closeMenuDrawer(event, elementToFocus = false) {
      if (event === undefined) return;
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
        submenu.classList.remove('submenu-open');
      });
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
    onFocusOut(event) {
      setTimeout(() => {
        if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
      });
    }
    onCloseButtonClick(event) {
      const detailsElement = event.currentTarget.closest('details');
      this.closeSubmenu(detailsElement);
    }
    closeSubmenu(detailsElement) {
      const parentMenuElement = detailsElement.closest('.submenu-open');
      parentMenuElement && parentMenuElement.classList.remove('submenu-open');
      detailsElement.classList.remove('menu-opening');
      detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
      removeTrapFocus(detailsElement.querySelector('summary'));
      this.closeAnimation(detailsElement);
    }
    closeAnimation(detailsElement) {
      let animationStart;
      const handleAnimation = (time) => {
        if (animationStart === undefined) {
          animationStart = time;
        }
        const elapsedTime = time - animationStart;
        if (elapsedTime < 400) {
          window.requestAnimationFrame(handleAnimation);
        } else {
          detailsElement.removeAttribute('open');
          if (detailsElement.closest('details[open]')) {
            trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
          }
        }
      }
      window.requestAnimationFrame(handleAnimation);
    }
  }
  customElements.define('menu-drawer', MenuDrawer);
  class HeaderDrawer extends MenuDrawer {
    constructor() {
      super();
    }
    openMenuDrawer(summaryElement) {
      this.header = this.header || document.getElementById('shopify-section-header') || document.getElementById('shopify-section-lp-header') || document.querySelector('.section-header');
      this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
      document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
      this.header.classList.add('menu-open');
      setTimeout(() => {
        this.mainDetailsToggle.classList.add('menu-opening');
      });
      summaryElement.setAttribute('aria-expanded', true);
      trapFocus(this.mainDetailsToggle, summaryElement);
      document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    }
    closeMenuDrawer(event, elementToFocus) {
      super.closeMenuDrawer(event, elementToFocus);
      this.header.classList.remove('menu-open');
    }
  }
  customElements.define('header-drawer', HeaderDrawer);
  class ModalDialog extends HTMLElement {
    constructor() {
      super();
      this.querySelector('[id^="ModalClose-"]').addEventListener(
        'click',
        this.hide.bind(this, false)
      );
      this.addEventListener('keyup', (event) => {
        if (event.code.toUpperCase() === 'ESCAPE') this.hide();
      });
      if (this.classList.contains('media-modal')) {
        this.addEventListener('pointerup', (event) => {
          if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
        });
      } else {
        this.addEventListener('click', (event) => {
          if (event.target === this) this.hide();
        });
      }
    }
    connectedCallback() {
      if (this.moved) return;
      this.moved = true;
      document.body.appendChild(this);
    }
    show(opener) {
      this.openedBy = opener;
      const popup = this.querySelector('.template-popup');
      document.body.classList.add('overflow-hidden');
      this.setAttribute('open', '');
      if (popup) popup.loadContent();
      trapFocus(this, this.querySelector('[role="dialog"]'));
      window.pauseAllMedia();
    }
    hide() {
      document.body.classList.remove('overflow-hidden');
      document.body.dispatchEvent(new CustomEvent('modalClosed'));
      this.removeAttribute('open');
      removeTrapFocus(this.openedBy);
      window.pauseAllMedia();
    }
  }
  customElements.define('modal-dialog', ModalDialog);
  class ModalOpener extends HTMLElement {
    constructor() {
      super();
      const button = this.querySelector('button');
      if (!button) return;
      button.addEventListener('click', () => {
        const modal = document.querySelector(this.getAttribute('data-modal'));
        if (modal) modal.show(button)
      });
    }
  }
  customElements.define('modal-opener', ModalOpener);
  class DeferredMedia extends HTMLElement {
    constructor() {
      super();
      const poster = this.querySelector('[id^="Deferred-Poster-"]');
      if (!poster) return;
      poster.addEventListener('click', this.loadContent.bind(this));
      poster.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        this.loadContent();
      });
    }
    loadContent(focus = true) {
      window.pauseAllMedia();
      if (!this.getAttribute('loaded')) {
        const content = document.createElement('div');
        content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));
        this.setAttribute('loaded', true);
        const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
        if (focus) deferredElement.focus();
      }
    }
  }
  customElements.define('deferred-media', DeferredMedia);
  
  function getPurchaseOptSelectedValue(name) {
    const radios = document.getElementsByName(name); // Get all radio buttons by name
    for (const radio of radios) {
      if (radio.checked) {
        return radio.value; // Return the value of the selected radio button
      }
    }
    return null; // Return null if no radio button is selected
  }
  class SliderComponent extends HTMLElement {
    constructor() {
      super();
      this.slider = this.querySelector('[id^="Slider-"]');
      this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
      this.enableSliderLooping = false;
      this.currentPageElement = this.querySelector('.slider-counter--current');
      this.pageTotalElement = this.querySelector('.slider-counter--total');
      this.prevButton = this.querySelector('button[name="previous"]');
      this.nextButton = this.querySelector('button[name="next"]');
      if (!this.slider || !this.nextButton) return;
      this.initPages();
      const resizeObserver = new ResizeObserver(entries => this.initPages());
      resizeObserver.observe(this.slider);
      this.slider.addEventListener('scroll', this.update.bind(this));
      this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
      this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
    }
    initPages() {
      this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
      if (this.sliderItemsToShow.length < 2) return;
      this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
      this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
      this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
      this.update();
    }
    resetPages() {
      this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
      this.initPages();
    }
    update() {
      const previousPage = this.currentPage;
      this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;
      if (this.currentPageElement && this.pageTotalElement) {
        this.currentPageElement.textContent = this.currentPage;
        this.pageTotalElement.textContent = this.totalPages;
      }
      if (this.currentPage != previousPage) {
        this.dispatchEvent(new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1]
          }
        }));
      }
      if (this.enableSliderLooping) return;
      if (this.prevButton) {
        if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
          this.prevButton.setAttribute('disabled', 'disabled');
        } else {
          this.prevButton.removeAttribute('disabled');
        }
      }
      if (this.nextButton) {
        if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
          this.nextButton.setAttribute('disabled', 'disabled');
        } else {
          this.nextButton.removeAttribute('disabled');
        }
      }
    }
    isSlideVisible(element, offset = 0) {
      const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
      return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
    }
    onButtonClick(event) {
      event.preventDefault();
      const step = event.currentTarget.dataset.step || 1;
      this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
      this.slider.scrollTo({
        left: this.slideScrollPosition
      });
    }
  }
  customElements.define('slider-component', SliderComponent);
  class SlideshowComponent extends SliderComponent {
    constructor() {
      super();
      this.sliderControlWrapper = this.querySelector('.slider-buttons');
      this.enableSliderLooping = true;
      if (!this.sliderControlWrapper) return;
      this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
      if (this.sliderItemsToShow.length > 0) this.currentPage = 1;
      this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
      this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
      this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
      this.setSlideVisibility();
      if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
    }
    setAutoPlay() {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.autoplaySpeed = this.slider.dataset.speed * 1000;
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.addEventListener('mouseover', this.focusInHandling.bind(this));
      this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
      this.addEventListener('focusin', this.focusInHandling.bind(this));
      this.addEventListener('focusout', this.focusOutHandling.bind(this));
      this.play();
      this.autoplayButtonIsSetToPlay = true;
    }
    onButtonClick(event) {
      super.onButtonClick(event);
      const isFirstSlide = this.currentPage === 1;
      const isLastSlide = this.currentPage === this.sliderItemsToShow.length;
      if (!isFirstSlide && !isLastSlide) return;
      if (isFirstSlide && event.currentTarget.name === 'previous') {
        this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
      } else if (isLastSlide && event.currentTarget.name === 'next') {
        this.slideScrollPosition = 0;
      }
      this.slider.scrollTo({
        left: this.slideScrollPosition
      });
    }
    update() {
      super.update();
      this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
      this.prevButton.removeAttribute('disabled');
      if (!this.sliderControlButtons.length) return;
      this.sliderControlButtons.forEach(link => {
        link.classList.remove('slider-counter__link--active');
        link.removeAttribute('aria-current');
      });
      this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
      this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
    }
    autoPlayToggle() {
      this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
      this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
      this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
    }
    focusOutHandling(event) {
      const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    }
    focusInHandling(event) {
      const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    }
    play() {
      this.slider.setAttribute('aria-live', 'off');
      clearInterval(this.autoplay);
      this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
    }
    pause() {
      this.slider.setAttribute('aria-live', 'polite');
      clearInterval(this.autoplay);
    }
    togglePlayButtonState(pauseAutoplay) {
      if (pauseAutoplay) {
        this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
        this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
      } else {
        this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
        this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
      }
    }
    autoRotateSlides() {
      const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
      this.slider.scrollTo({
        left: slideScrollPosition
      });
    }
    setSlideVisibility() {
      this.sliderItemsToShow.forEach((item, index) => {
        const linkElements = item.querySelectorAll('a');
        if (index === this.currentPage - 1) {
          if (linkElements.length) linkElements.forEach(button => {
            button.removeAttribute('tabindex');
          });
          item.setAttribute('aria-hidden', 'false');
          item.removeAttribute('tabindex');
        } else {
          if (linkElements.length) linkElements.forEach(button => {
            button.setAttribute('tabindex', '-1');
          });
          item.setAttribute('aria-hidden', 'true');
          item.setAttribute('tabindex', '-1');
        }
      });
    }
    linkToSlide(event) {
      event.preventDefault();
      const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
      this.slider.scrollTo({
        left: slideScrollPosition
      });
    }
  }
  customElements.define('slideshow-component', SlideshowComponent);
  class VariantSelects extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('change', this.onVariantChange);
    }
    onVariantChange() {
      this.updateOptions();
      this.updateMasterId();
      this.toggleAddButton(true, '', false);
      this.updatePickupAvailability();
      this.removeErrorMessage();
      this.customerMember = document.body.classList.contains('customer-member');
      if (!this.currentVariant) {
        this.toggleAddButton(true, '', true);
        this.setUnavailable();
      } else {
        // this.updateMedia();
        if (typeof this.dataset.shop === 'undefined' && this.dataset.shop === null) {
          this.updateURL();
          this.updateVariantInput();
          this.renderProductInfo();
        } else {
          var productForm = document.getElementById(`product-form-${this.dataset.section}`);          
          const seling_plan = productForm.querySelector('[name="selling_plan"]');
          const selectedValue = getPurchaseOptSelectedValue('purchaseOption');
          if (this.customerMember) {
            window.variantStrings.addToCart = "Add to Kit";
            if (seling_plan == null || selectedValue == 'onetime') {
              window.variantStrings.addToCart = "Buy Now";
            }
          } else {
            window.variantStrings.addToCart = "Subscribe";
            if (seling_plan == null || selectedValue == 'onetime') {
              window.variantStrings.addToCart = "Add to Cart";
            }
          }
          this.updateVariantInput();
          this.renderProductInfoForShop();
        }
        this.updateShareUrl();
      }
    }
   shop_qty_limit_btn_click() {
      try {
          fetch(window.Shopify.routes.root + 'cart.js?for=qty_limit_global_js')
              .then(response => response.json())
              .then(data => {
                  const items = data.items;
                  var filteredItems = items.filter(function(item) {
                      return typeof item.selling_plan_allocation?.selling_plan.id === "number";
                  });
                  filteredItems.forEach(item => {
                      var cart_item_qty = parseInt(item.quantity);
                      var cart_variant_id = parseInt(item.id);
                      var variant_id = parseInt($("#subscribe-" + item.product_id).find('[name="id"]').val(), 10);

                      if (cart_variant_id === variant_id) {
                          if (cart_item_qty <= 3) {
                              $("#subscribe-" + item.product_id).find(".addto-cart-button-subscribe").prop('disabled', false);
                              $(".shop-qty-error").remove();
                              if ($("#subscribe-" + item.product_id).find(".ingpopup .shop-qty-error").length > 0) {
                                  $("#subscribe-" + item.product_id).find(".ingpopup .shop-qty-error").remove();
                                  console.log('added cart');
                              }
                          }
                      }
                  });
              });
      } catch (e) {
          console.error(e);
      }
  }
    updateOptions() {
      this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
    }
    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options.map((option, index) => {
          return this.options[index] === option;
        }).includes(false);
      });
    }
    updateMedia() {
      if (!this.currentVariant) return;
      if (!this.currentVariant.featured_media) return;
      const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
      mediaGalleries.forEach(mediaGallery => {
        if (typeof mediaGallery.setActiveMedia === 'function') {
          mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);
        }
      });
      const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
      if (!modalContent) return;
      const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
      modalContent.prepend(newMediaModal);
    }
    updateURL() {
      const is_shop_page = document.querySelector(`.is_shop_page`);
      const variant_url = document.querySelectorAll(`.product-link-${this.dataset.productid}`);
      // On the Shop page we re-point product links to the selected variant.
      // Guard against missing data (otherwise href can become "undefined?variant=...").
      if (this.dataset.url && this.currentVariant && this.currentVariant.id) {
        variant_url.forEach(element => {
          element.setAttribute('href', this.dataset.url + '?variant=' + this.currentVariant.id);
        });
      }
      const product_urls = document.getElementsByClassName("popup-product-" + this.dataset.productid);
      if (product_urls.length > 0) {
        for (let i = 0; i < product_urls.length; i++) {
          product_urls[i].classList.add("hide");
        }
      }
      const variant_prices = document.getElementsByClassName("popup-variant-price-" + this.currentVariant.id);
      if (variant_prices.length > 0) {
        variant_prices[0].classList.remove("hide");
      }
      if (!this.currentVariant || this.dataset.updateUrl === 'false' || is_shop_page) return;
      window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
      fetch(`${this.dataset.url}.json`)
        .then((response) => response.json())
        .then((responseJson) => {
          const variant = responseJson.product.variants.find(v => v.id === this.currentVariant.id);
          const price = variant ? variant.price : null;
          const priceElement = document.getElementById("rc-onetime-price");
          if (priceElement) {
            priceElement.innerText = "$" + price;
          }
        });
    }
    updateShareUrl() {
      const shareButton = document.getElementById(`Share-${this.dataset.section}`);
      if (!shareButton || !shareButton.updateUrl) return;
      shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateLineItemId(productForm,variantId){
       const line_item_id = productForm.querySelector('[name="properties[_line_item_id]"]');
      if(line_item_id){
            const line_item_id_subcription = productForm.querySelector('[name="line_item_id_subcription"]');
            const line_item_id_one_time = productForm.querySelector('[name="line_item_id_one_time"]');
          

            const line_item_id_subcription_value = line_item_id_subcription.value;
            const line_item_id_one_time_value = line_item_id_one_time.value;
            const line_item_id_value = line_item_id.value;

            const newVariant = variantId; 
            const line_item_id_subcription_updatedValue = line_item_id_subcription_value.replace(/^[^:]+/, newVariant);
            const line_item_id_one_time_updatedValue = line_item_id_one_time_value.replace(/^[^:]+/, newVariant);
            const  line_item_id_updatedValue = line_item_id_value.replace(/^[^:]+/, newVariant);
            
            line_item_id_subcription.value = line_item_id_subcription_updatedValue;
            line_item_id_one_time.value = line_item_id_one_time_updatedValue;
            line_item_id.value = line_item_id_updatedValue; 
      }
     

    }

    updateVariantInput() {
      var productForms = document.querySelectorAll(
        `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
      );
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;

        this.updateLineItemId(productForm,this.currentVariant.id)
        
     // Dynamic inputs based on variant ID
    const preupsellVariant = productForm.querySelector(`[name="_preupsell_variants_${this.currentVariant.id}"]`);
    const preupsellDefault = productForm.querySelector(`[name="_preupsell_variants_default"]`);
    const targetInput = productForm.querySelector('[name="properties[_preupsell_variants]"]');

    if (targetInput) {
      targetInput.value = preupsellVariant?.value || preupsellDefault?.value || '';
    }

    console.log("Input value changed to:", input.value);
        
        input.dispatchEvent(new Event('change', {
          bubbles: true
        }));
    
        try {
            
            const qtyError = productForm.querySelector(
              '.qty-error, [class^="qty-error"]'
            );


            if (qtyError !== null) {
              qtyError.remove();
              $('.qty-error').remove();
              $('[class^="qty-error"]').remove();
              $(".addto-cart-button").removeClass("button_or_link_disabled")
              $(".addto-cart-button").prop("disabled", false);
            }
          } catch (error) {
            console.error('Error removing qty-error:', error);
          }
          try {
            const ingPopup = productForm.closest('.ingpopup');
            if (ingPopup) {
              const shopqtyErrors = ingPopup.querySelectorAll('.shop-qty-error');
              shopqtyErrors.forEach((shopqtyError) => {
                shopqtyError.remove();
              });
            }
          } catch (error) {
            console.log(error);
          }
      });

    }
    updatePickupAvailability() {
      const pickUpAvailability = document.querySelector('pickup-availability');
      if (!pickUpAvailability) return;
      if (this.currentVariant && this.currentVariant.available) {
        if (pickUpAvailability) {
          pickUpAvailability.fetchAvailability(this.currentVariant.id);
        }
      } else {
        if (pickUpAvailability) {
          pickUpAvailability.removeAttribute('available');
          pickUpAvailability.innerHTML = '';
        }
      }
    }
    removeErrorMessage() {
      const section = this.closest('section');
      if (!section) return;
      const productForm = section.querySelector('.product-form');
      if (productForm && typeof productForm.handleErrorMessage === 'function') {
        productForm.handleErrorMessage();
      }
    }
    renderProductInfo() {
      fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html')
          const destination = document.getElementById(`price-${this.dataset.section}`);
          const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
          if (source && destination) destination.innerHTML = source.innerHTML;
          const price = document.getElementById(`price-${this.dataset.section}`);
          if (price) price.classList.remove('visibility-hidden');
          this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
          var productTitle = document.querySelector('a.product__title');
          if (productTitle && (productTitle.dataset.handle === 'age-defying-body-face-kit' || productTitle.dataset.handle === '2-step-body-kit')) {
            var addToCartLabel = document.querySelector('.add_to_cart_label');
            if (addToCartLabel) {
              addToCartLabel.innerHTML = 'Add to Cart';
            }
          }
        });
    }
    renderProductInfoForShop() {
      fetch(`${this.dataset.url}?&variant=${this.currentVariant.id}&section=main-product`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html')
          const destination = document.getElementById(`price-${this.dataset.section}`);
          const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
          if (source && destination) destination.innerHTML = source.innerHTML;
          const price = document.getElementById(`price-${this.dataset.section}`);
          if (price) price.classList.remove('visibility-hidden');
          this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
        });
    }
    addToCartLabelText() {
      var productTitle = document.querySelector('a.product__title');
      var productHandles = ['age-defying-body-face-kit', '2-step-body-kit'];
      if (productTitle && productHandles.includes(productTitle.dataset.handle)) {
        var addToCartLabel = document.querySelector('.add_to_cart_label');
        if (addToCartLabel) {
          addToCartLabel.innerHTML = 'Add to Cart';
        }
      }
    }
    toggleAddButton(disable = true, text, modifyClass = true) {
      var productForm = document.getElementById(`product-form-${this.dataset.section}`);
      if (!productForm) return;
      const addButton = productForm.querySelector('[name="add"]');
      const addButtonText = productForm.querySelector('[name="add"] > span');
      const seling_plan = productForm.querySelector('[name="selling_plan"]')
      if (!addButton) return;
      if (disable) {
        addButton.setAttribute('disabled', 'disabled');
        if (text) addButtonText.textContent = text;
        this.addToCartLabelText();
      } else {
        addButton.removeAttribute('disabled');
        if (seling_plan && seling_plan.value != "") {
          addButtonText.textContent = "Subscribe";
          this.addToCartLabelText();
        } else {
          addButtonText.textContent = window.variantStrings.addToCart;
        }
      }
      if (!modifyClass) return;
    }
    setUnavailable() {
      const button = document.getElementById(`product-form-${this.dataset.section}`);
      const addButton = button.querySelector('[name="add"]');
      const addButtonText = button.querySelector('[name="add"] > span');
      const price = document.getElementById(`price-${this.dataset.section}`);
      if (!addButton) return;
      addButtonText.textContent = window.variantStrings.unavailable;
      if (price) price.classList.add('visibility-hidden');
    }
    getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
  }
  customElements.define('variant-selects', VariantSelects);
  class VariantRadios extends VariantSelects {
    constructor() {
      super();
    }
    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      });
    }
  }
  customElements.define('variant-radios', VariantRadios);
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
            if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
              this.remove();
            }
            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }
      new IntersectionObserver(handleIntersection.bind(this), {
        rootMargin: '0px 0px 400px 0px'
      }).observe(this);
    }
  }
  customElements.define('product-recommendations', ProductRecommendations);
  //Subscription section Recharge app flow modiifed //
  function rcWidjectCustomize(skipIfLoggedIn=true) {
    setTimeout(function() {
      if($('.cancel-subscription-selected').length>0) { 
       const one_time_label = $('.rc-radio.onetime-radio .rc-radio__label').html();
          if (one_time_label && one_time_label.includes('One-time Purchase')) {
            const onetime = one_time_label.split('One-time Purchase');
            const label = 'One-time Purchase';
            const price = onetime[1]?.trim();  
           const radio_label = '<div class="onetime-footer-label">'+label+'</div><div style="font-weight:bold;">'+price+'</div>';
            $('.rc-widget .rc-radio.onetime-radio .rc-radio__label').html(radio_label);
          } 
        }
     }, 2500);
    
    // If the user is logged in, abort widget customization because we handle that elsewhere.
    if (skipIfLoggedIn && window.SESSION_CUSTOMER_CACHE_KEY) {
      return;
    }
    setTimeout(function() {

      let oneTime = $('.onetime-radio .rc-radio__label').text();
      let splitedPrice = oneTime.split('$');
      let finalPrice = splitedPrice.pop();
      $('.recharge-subscription-widget').css('display', 'block');
      let originalPrice = $('.product__info-wrapper .price__container .price__sale s.price-item--regular').text().trim();
      let cleanedPrice = originalPrice.replace(/[^0-9.]/g, '');
      let formattedPrice = '$' + parseFloat(cleanedPrice || '0').toFixed(2);
      var combinedContent = '';
      if ($('.price-section .offer-price-block').length > 0) {
        var offerPercentage = $('.offer-price-block .offer-percentage').text();
        splitedPrice = splitedPrice + ': <b>SAVE ' + offerPercentage + '%</b>';
        originalPrice = $('.offer-price-block .original-price-item').text();
        var originalPriceValue = originalPrice.replace(/[^0-9.]/g, '');
        var orginalPriceOneTime = '$' + parseFloat(originalPriceValue).toFixed(2);
        var offerPrice = $('.offer-price-block .offer-price-item').text();
        finalPrice = '<s>' + orginalPriceOneTime + '</s><span class="offer-price">' + offerPrice + '</span>';
        combinedContent = 'One-Time Purchase ' + splitedPrice;
        var stickyfooterstrikeprice = '';
        if (originalPrice != '') {
          stickyfooterstrikeprice = '<s>' + formattedPrice + '</s>';
        }
        $('.pdp-sticky-footer .sticky-footer-price').html(stickyfooterstrikeprice + $('.subscription-radio .rc-radio__price').text());
      } else {
        finalPrice = '$' + finalPrice;
        var stickyfooterstrikeprice = '';
        if (originalPrice != '') {
          stickyfooterstrikeprice = '<s>' + formattedPrice + '</s>';
        }
        var subcription_activeRadio = $('.rc-widget .subscription-radio').length;
        var onetime_activeRadio = $('.rc-widget .onetime-radio').length;
        if (subcription_activeRadio > 0 && onetime_activeRadio > 0) {
          $('.pdp-sticky-footer .sticky-footer-price').html(
            '<span class="pdp-price-span no-compare-price">' + $('.rc-radio--active.subscription-radio .rc-radio__price').html() + '</span>'
          );
        } else {
          $('.pdp-sticky-footer .sticky-footer-price').html(
            $('.product__info-container .price-container').clone().find('.menbership').remove().end()
          );
        }
        combinedContent = 'Try once';
      }
      $(".onetime-radio").insertAfter("div.rc-template__radio");
      var $otFirst = $('.onetime-radio').first();
      if (
        !$otFirst.length ||
        $otFirst.children('.rc-radio__label').length < 2
      ) {
        $('.onetime-radio .rc-radio__label')
          .clone()
          .insertAfter('.onetime-radio span.rc-radio__label')
          .html(splitedPrice);
      }
      $('.custom-onetime-radio .onetime-radio-label').html(combinedContent);
      $('.onetime-radio span.rc-radio__label:nth-child(2)')
        .attr('id', 'rc-onetime-price')
        .html(finalPrice)
        .addClass('radio__label__price');
      $('.rc-selling-plans').insertAfter('.subscription-radio .rc-radio__label');
      $('.save-and-subscribe-pdp-text').insertAfter('.subscription-radio .rc-radio__label');
      $('.ytpdp-save-and-subscribe').insertAfter('.subscription-radio .rc-radio__label');
      if (originalPrice != '') {
        $('.subscription-radio .rc-radio__price').html('<s>'+ '<span class="visually-hidden">Original price</span>' + formattedPrice + '</s>'+ '<span class="visually-hidden">Sale price</span>' + $('.subscription-radio .rc-radio__price').text());
      }
      $('.shipping-frequency-section').clone().insertAfter(
        '.rc-selling-plans .rc-selling-plans-single, .rc-selling-plans .rc-selling-plans-dropdown .rc-selling-plans-dropdown__select'
      );
      $('.technology-section').insertAfter('#benefits');
      $('.rc-widget .save-and-subscribe-pdp').css('display', 'flex');
      if ($('[name="purchaseOption"]').val() == "subscription") {
        $(".product-form__buttons").find(".product-form__submit > span").text("Subscribe");
      }
      if ($('[name="purchaseOption"]').val() == "membership") {
        $(".product-form__buttons").find(".product-form__submit > span").text("LEARN MORE");
      }
      updateRadioLabelClasses();
      if ($('.recharge-subscription-widget .rc-widget').length == 0) {
        function formattedPriceFinal(selector, prefix) {
          var priceText = $(selector).text();
          var priceValue = parseFloat(priceText.replace(/[^0-9.]/g, ''));
          var FianlFormattedPrice = prefix + priceValue.toFixed(2);
          return FianlFormattedPrice;
        }
        var offOneTimePriceFinal = formattedPriceFinal('.offer-price-block .offer-price-item', '$');
        var offOneTimePriceSticky = formattedPriceFinal('.offer-price-block s.original-price-item', '$');
        var CustomFormattedPrice = formattedPriceFinal('.product__info-wrapper .price-section .price__container .price__sale .price-item', '$');
        if ($('.offer-price-block').length > 0) {
          $('.custom-onetime-radio .price-label').html('<s>' + offOneTimePriceSticky + '</s>' + offOneTimePriceFinal);
          $('.pdp-sticky-footer .sticky-footer-price').html('<s>' + offOneTimePriceSticky + '</s>' + offOneTimePriceFinal);
        } else {
          $('.custom-onetime-radio .price-label').html('<s>' + $('.product__info-wrapper .price__container .price-section s.price-item--regular').text() + '</s>' + CustomFormattedPrice);
        }
        $('.custom-rc-widget').removeClass('hide');
      }
      if ($('.custom-pdp-label').hasClass('membership-radio')) {
        $('.rc-widget label').removeClass('rc-radio--active');
        updateRadioLabelClasses();
      }
      var default_selected_radio = document.querySelector('.default_selected_value');
      if (default_selected_radio) {
        var default_selected_value = default_selected_radio.value;
        if (default_selected_value !== '') {
          var radioButtonValue = '';
          if (default_selected_value === 'upsell_product') {
            radioButtonValue = 'membership';
          } else if (default_selected_value === 'onetime') {
            radioButtonValue = 'onetime';
          } else if (default_selected_value === 'subscription') {
            radioButtonValue = 'subscription';
          }
          var radioBtn = document.querySelector('input[type="radio"][value="' + radioButtonValue + '"]');
          if (radioBtn) {
            var radioBtnId = radioBtn.id;
            document.querySelectorAll('label').forEach(function(label) {
              if (label.closest('.rc-widget')) {
                return;
              }
              label.classList.remove('rc-radio--active', 'ce-rc-active');
            });
            radioBtn.checked = true;
            radioBtn.dispatchEvent(new Event('change', {
              bubbles: true
            }));
            radioBtn.dispatchEvent(new Event('click', {
              bubbles: true
            }));
            var label = radioBtn.closest('label') || document.querySelector('label[for="' + radioBtnId + '"]');
            if (label) {
              label.classList.add('rc-radio--active', 'ce-rc-active');
              label.dispatchEvent(new Event('click', {
                bubbles: true
              }));
            }
            var activeLabel = document.querySelector('.rc-radio--active');
            if (activeLabel) {
              label.classList.add('rc-radio--active', 'ce-rc-active');
              activeLabel.dispatchEvent(new Event('change', {
                bubbles: true
              }));
            }
          }
          updateRadioLabelClasses();
        }
        // custom code
        // $(".rc-widget .subscription-radio input").trigger("click");
        // if($(".pdp-subcription-products").length){
        //   $('.rc-radio.membership-radio input').trigger('click');
        // }
        if ($('body').hasClass('cancel-subscription-selected')) {
          $(".rc-widget .subscription-radio input").trigger("click");
        }

      }

      syncRechargeRadioAccessibility();
      function stikcyFooterPriceUpdate(){
        let pdpstrikePrice = $('.subscription-radio .rc-radio__label .rc-radio__price s');
        if (pdpstrikePrice.length) {
          $('.sticky-footer-price .pdp-price-span').prepend(pdpstrikePrice.clone());
        }
      }
      stikcyFooterPriceUpdate();
    }, 2500);
    setTimeout(function() {
      updateRadioLabelClasses();
      syncRechargeRadioAccessibility();
    }, 2800);
  }

  function syncRechargeRadioAccessibility() {
    try {
      // Prefer the widget in .custom-pdp (default PDP); accordion-first often matches nothing and skips labeling.
      var $w = $('.custom-pdp .recharge-subscription-widget .rc-widget').first();
      if (!$w.length) {
        $w = $('.product__accordion__main .recharge-subscription-widget .rc-widget').first();
      }
      if (!$w.length) {
        $w = $('.recharge-subscription-widget .rc-widget').first();
      }
      if (!$w.length) return;
      var subParts = [];
      $w.find('label.subscription-radio .rc-radio__label').first().each(function () {
        subParts.push($(this).text().replace(/\s+/g, ' ').trim());
      });
      var subName = subParts.join(' ').trim() || 'Subscribe and save';
      var subPrice = ($w.find('label.subscription-radio .rc-radio__price').first().text() || '').replace(/\s+/g, ' ').trim();
      var oneParts = [];
      $w.find('label.onetime-radio .rc-radio__label').each(function () {
        var t = $(this).text().replace(/\s+/g, ' ').trim();
        if (t) oneParts.push(t);
      });
      var onceName = oneParts.join(' ').trim() || 'Try once';
      var onePrice = ($w.find('#rc-onetime-price').text() || $w.find('.onetime-radio .radio__label__price').text() || '').replace(/\s+/g, ' ').trim();
      var subAnnounce = subName + (subPrice ? ', ' + subPrice : '');
      var oneAnnounce = onceName + (onePrice ? ', ' + onePrice : '');
      $w.find('input[name="purchaseOption"][value="subscription"]').attr('aria-label', subAnnounce);
      $w.find('input[name="purchaseOption"][value="onetime"]').attr('aria-label', oneAnnounce);
      var ytPlanDesc = [];
      $('.pdp-yt-product [id^="yt-pdp-select-plan-heading-"]').each(function () {
        if (this.id) ytPlanDesc.push(this.id);
      });
      $('.pdp-yt-product .yt-pdp-plan-keys').each(function () {
        if (this.id) ytPlanDesc.push(this.id);
      });
      if (ytPlanDesc.length) {
        var ytDb = ytPlanDesc.join(' ');
        $w
          .find('input[name="purchaseOption"][value="subscription"], input[name="purchaseOption"][value="onetime"]')
          .attr('aria-describedby', ytDb);
      }
      $('section.pdp-body-repair-treatment input[name="purchaseOption"][value="onetime"]').attr({ tabindex: '-1', 'aria-hidden': 'true' });
      $w.find('label.membership-radio input[type="radio"]').each(function () {
        var t = $(this).closest('label.membership-radio').find('.rc-radio__label').first().text().replace(/\s+/g, ' ').trim();
        if (t) $(this).attr('aria-label', t);
      });
      $('.pdp-subcription-products label.membership-radio input[type="radio"]').each(function () {
        var t = $(this).closest('label.membership-radio').find('.rc-radio__label').first().text().replace(/\s+/g, ' ').trim();
        if (t) $(this).attr('aria-label', t);
      });
    } catch (e) {}
  }
  
  function updateRadioLabelClasses() {
    $('label').not('.rc-widget label.rc-radio').removeClass('ce-rc-active');
    $('input[name="purchaseOption"]').each(function() {
      if ($(this).is(':checked')) {
        if ($(this).closest('label').length) {
          $(this).closest('label').addClass('ce-rc-active');
        } else {
          let id = $(this).attr('id');
          $('label[for="' + id + '"]').addClass('ce-rc-active');
        }
        return false;
      }
    });
  }
  $(document).on('change', 'input[name="purchaseOption"]', function() {
    $('label').removeClass('ce-rc-active');
    if ($(this).closest('label').length) {
      $(this).closest('label').addClass('ce-rc-active');
    } else {      
      let id = $(this).attr('id');
      $('label[for="' + id + '"]').addClass('ce-rc-active');
    }
    setTimeout(syncRechargeRadioAccessibility, 150);

    if($("body").hasClass("cancel-subscription-selected")) {
      if($(".subscription-radio").hasClass("rc-radio--active")){
        $("#addToCartPdp").html("Subscribe");
      }else{
       $("#addToCartPdp").html("Add to cart");
      } 
      $("#footer-cta-pdp .add_to_cart_label").html($("#addToCartPdp").html());
    }

  });

  $(document).on('click', '.subscription-radio, .onetime-radio', function(skipIfLoggedIn=true) {
    setTimeout(function() {
      if ($('.shipping-frequency-section--rc-insert').length === 0 && $('.subscription-radio .shipping-frequency-section').length === 0) {
        var $tpl = $('.product__accordion__main .shipping-frequency-section.hide').add('.product__info-container .shipping-frequency-section.hide').first();
        if ($tpl.length) {
          $tpl.clone(true, true).removeClass('hide').addClass('shipping-frequency-section--rc-insert').insertAfter('.rc-selling-plans .rc-selling-plans-single, .rc-selling-plans .rc-selling-plans-dropdown .rc-selling-plans-dropdown__select');
        }
      }
    }, 500);
    setTimeout(syncRechargeRadioAccessibility, 400);
    if ($(this).hasClass('onetime-radio')) {
      $('.product-form__quantity').show();
      $('.product-form').addClass('onetime-selected');
      $('.product-form__quantity').find('.quantity__button').removeAttr("disabled");
      $('.product-form__quantity').find('.quantity__input').removeAttr("readonly");
    } else {
      $('.product-form__quantity').hide();
      $('.product-form').removeClass('onetime-selected');
      $('.product-form__quantity').find('.quantity__button').attr("disabled", true);
      $('.product-form__quantity').find('.quantity__input').attr("readonly", true);
    }
  });
  $(document).on('click', '.shipping-frequency-section label', function() {
    $('.shipping-frequency-section .paymentOpTooltip').toggleClass('active');
  });
  $(document).ready(function() {
    rcWidjectCustomize();

    $(".pdp-page , .pdp-product-section").on('click', function(e) {
      if (!$(e.target).is('.shipping-frequency-section label')) {
        $('.shipping-frequency-section .paymentOpTooltip').removeClass('active');
      }
    });
    $('.pdp-sticky-footer .btn-checkout').on("click", function() {
      $('.buy-button .addto-cart-button').trigger('click');
    });
    $('.pdp-sticky-footer .btn-checkout-wrapper, .pdp-sticky-footer #footer-cta-pdp').on("click", function() {
      $("html, body").animate({
        scrollTop: $(".addto-cart-button").offset().top - 100
      });
    });
  });
  $('.nonvimeo-close-info-modal').click(function() {
    $('.video-player-modal').removeClass('visible');
    $('body').removeClass('no-scroll');
    $('html').css("overflow-y", "visible");
    var pauseVideo = $(".non-vimeo-video").attr("id");
    $('video#' + pauseVideo).trigger('pause');
  });
  $(document).ready(function() {
     let firstClickPrevented = false;
     $(".mega-menu").on("click", function(event) {  
        if ($(event.target).hasClass("yt-main-menu") && window.innerWidth > 1200) {  
            if (!firstClickPrevented) {
                event.preventDefault();
                firstClickPrevented = true;
            } else if ($(this).hasClass("menu-open") && $(this).hasClass("ce-menu-selected")) {
                firstClickPrevented = false;
            } else {
                event.preventDefault();
            }
        }
  
        if ($(this).prop('open')==false) { 
            $(this).toggleClass("menu-open");          
        } else {
            $(this).prop('open',true); 
            $(this).addClass("ce-menu-selected");           
        }       
        if($(this).hasClass('menu-open')) {
           $(this).addClass("ce-menu-selected"); 
           $(this).addClass("menu-open"); 
           $(this).prop('open',true); 
        }
      });
    
    $('.card__inner .card__media').on('mouseenter', function() {
      if ($(window).width() > 1024) {
        $(this).find(".card-wrapper .card__content .quick-add.no-js-hidden").css({
          opacity: '1'
        });
      }
    });
  });
  // Reinitialize Slick slider when the orientation changes or on window resize
  $.fn.isInViewport = function() {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();
    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();
    return elementBottom > viewportTop && elementTop < viewportBottom;
  };
  function stickyPriceUpdate() {
    var subcription_activeRadio = $('.rc-widget .subscription-radio').length;
    var onetime_activeRadio = $('.rc-widget .onetime-radio').length;
    if ((subcription_activeRadio > 0) && (onetime_activeRadio > 0)) {
      var newPrice = $('.rc-radio__price').html();
      $('.rc-radio__label:nth-child(1)').html();
      $(".sticky-footer-price .pdp-price-span").html(newPrice);
    }
  }
  // Initialize Slick slider on page load if it's a mobile screen
  function isMobileScreen() {
      return $(window).width() < 640;
  } 
  // sticky footer price update based on the window load
  $(window).on('load', function() {
    if($("body").hasClass("cancel-subscription-selected")) {
      if($(".subscription-radio").hasClass("rc-radio--active")){
        $("#addToCartPdp").html("Subscribe");
      }else{
       $("#addToCartPdp").html("Add to cart");
      } 

      $("#footer-cta-pdp .add_to_cart_label").html($("#addToCartPdp").html());
    }
    stickyPriceUpdate();
  });
  //Sticky header close menu on menuitem click
  $('#shopify-section-lp-header a.list-menu__item, #shopify-section-lp9-header a.list-menu__item, #shopify-section-lp-sp13-header a.list-menu__item').on('click', function() {
    $('.menu-drawer-container').removeClass('menu-opening');
    $('summary.header__icon').trigger('click');
  });
  $('#shopify-section-lp-sp12-header a.list-menu__item, #shopify-section-lp-sp11-header a.list-menu__item').on('click', function() {
    $('.menu-drawer-container').removeClass('menu-opening');
    $('summary.header__icon').trigger('click');
  });
  // sas page loader
  $(document).ready(function() {
    setTimeout(function() {
      $(".sas-page-kits-section").show();
      $(".checkout-button").show();
      $(".spinner-icon").hide();
    }, 100);
  });
  // pdp bottom sticky remove empty strike tag when tag has no strike value
  function removepriceempty() {
    $('.sticky-footer-price s').filter(function() {
      return $(this).text().trim() === '';
    }).remove();
  }
  $(document).ready(function() {
    setInterval(removepriceempty, 1000);
  });
  if (window.location.href.includes('mbglink')) {
    $('.grid__item #mbglink details').attr('open', 'open');
    $(".sas-feature-section-block-wrapper a:eq(2)").addClass("active");
  }
/*******shop list *******/
document.addEventListener("DOMContentLoaded", function() {
  let sectionTitles = document.querySelectorAll(".product-colletction-main");
  sectionTitles.forEach(function(title) {
    let stickyOffset = title.offsetTop;
     window.addEventListener("scroll", function() {
      if (window.pageYOffset >= stickyOffset) {
        title.classList.add("sticky");
      } else {
        title.classList.remove("sticky");
      }
    });
  });
  if (window.innerWidth <= 1024) {
    sectionTitles.forEach(function(title) {
       title.classList.remove("sticky");
    });
  }
});

window.onload = function () {
  const desktopIframes = document.querySelectorAll('.resl-result-video-desktop');
  const mobileIframes = document.querySelectorAll('.resl-result-video-mobile');
  let players = [];
  let currentIndex = 0;
  let isInitialized = false;    
  const isMobile = window.innerWidth < 640;
  const targetIframes = isMobile ? mobileIframes : desktopIframes; 
  if (targetIframes.length === 0) return;   
  targetIframes.forEach((iframe, index) => {   
    players[index] = new Vimeo.Player(iframe);     
    players[index].on('ended', function (num) {       
      if (!isInitialized) return;        
      players[index].setCurrentTime(0); 
      currentIndex = (index + 1) % players.length;      
      let nextButton = document.querySelector('.video-btn-section')?.children[currentIndex];       
     if (nextButton) nextButton.click();
     players[currentIndex].play();
    });
  });
  
  Promise.all(players.map(player => player.getDuration()))
    .then(() => {   
      isInitialized = true;        
    })
    .catch(error => console.error('Error initializing players:', error));  
   document.querySelectorAll(".playlists").forEach((playlist, playlistIndex) => {
    playlist.removeEventListener("click", handlePlaylistClick);
    playlist.addEventListener("click", handlePlaylistClick.bind(null, playlistIndex));
  });

  function handlePlaylistClick(playlistIndex) {
    if (window.isVideoPlaying) return;
    window.isVideoPlaying = true;
    setTimeout(() => {
      window.isVideoPlaying = false;
    }, 500);     
    players.forEach(player => player.pause()); 
    currentIndex = playlistIndex;
    players[currentIndex].setCurrentTime(0).then(() => {
      players[currentIndex].play();
    });       
    let nextButton = document.querySelector('.video-btn-section')?.children[currentIndex];
    if (nextButton) nextButton.click();
  }
};

// hide shop title for subscription user 
$(document).ready(function () {
  setTimeout(function () {
    if ($('body').hasClass('customer-member') || $('body').hasClass('logged-in-user')) {
      const collectionContainers = document.querySelectorAll('.card__content .card-collection-data');
      collectionContainers.forEach(container => {
        const listItems = container.querySelectorAll('li.kit-product');
        const allHidden = listItems.length > 0 && Array.from(listItems).every(li => li.classList.contains('hidden'));
        if (allHidden) {
          container.classList.add('hidden');
        } else {
          container.classList.remove('hidden');
        }
      });
      document.querySelectorAll('a[data-attr], button[data-attr]').forEach(link => {        
        const targetId = link.getAttribute('data-attr');
        const targetElement = document.getElementById(targetId);
        if (targetElement && targetElement.classList.contains('hidden')) {
          const parentDiv = $(link.closest('.shop') || link.closest('li'));
          if (parentDiv.length) {
            parentDiv.addClass('hidden');
          }
        }
      });
    }
  }, 2000);
});

document.addEventListener("DOMContentLoaded", function () {
      function revealSections() {
        const sections = document.querySelectorAll(".preload");

        sections.forEach(section => {
          const rect = section.getBoundingClientRect();
          const sectionVisible = rect.top < window.innerHeight && rect.bottom > 0; // Checks for partial visibility          
          if (sectionVisible) {
            section.classList.add("visible");
          }
        });
      }

      // Run on scroll and resize
      window.addEventListener("scroll", revealSections);
      window.addEventListener("resize", revealSections);

      // Run on initial load
      revealSections();
    });
 window.onload = function () {
      setTimeout(() => { 
    const preloadDivs = document.querySelectorAll(".preload");   
    function isPartiallyInViewport(element) {
        const rect = element.getBoundingClientRect();
        return (
            rect.top < window.innerHeight &&   
            rect.bottom > 0 &&                
            rect.left < window.innerWidth &&   
            rect.right > 0                    
        );
    }  
    preloadDivs.forEach(div => {
        if (isPartiallyInViewport(div)) {
          div.classList.add("visible"); 
          div.classList.remove("preload");             
        }
    });  
      }, 0); 
};
function hideExfoliantOptions() {
  if (!$('body').hasClass('customer-member')) return;

  const items = $('.account-recommendations .react-multi-carousel-item');
  const itemCount = items.length;

  if (!itemCount) return;

  items.each(function () {
    const parent = $(this);
    const title = parent.find('.product-card-title').text().trim().toLowerCase();

    if (title.includes('body refining exfoliant')) {
      parent.find('.product-card-options').hide();
    }
  });
}
$(document).ajaxComplete(function () {
  hideExfoliantOptions();
});
$(document).ready(function() {
  $('.card__media .product-link-14737198612850 img.non-flip, .card__media .product-link-14737198612850 img.large-flip-card-front, .card__media .product-link-14812524511602 img.non-flip, .card__media .product-link-14812524511602 img.large-flip-card-front, .card__media .product-link-8858010124440 img.non-flip, .card__media .product-link-8858010124440 img.large-flip-card-front').attr('src', 'https://cdn.shopify.com/s/files/1/0608/9955/7528/files/YT_Shop_Flatlays_Deluxe_092225.jpg');
  $('.card__media .product-link-8747485823128 img.non-flip, .card__media .product-link-8747485823128 img.large-flip-card-front').attr('src', 'https://cdn.shopify.com/s/files/1/0608/9955/7528/files/YT_Shop_Flatlays_Deluxe_092225.jpg');
  $('.card__media .product-link-14737198416242 img.non-flip, .card__media .product-link-14737198416242 img.large-flip-card-front').attr('src', 'https://cdn.shopify.com/s/files/1/0608/9955/7528/files/YT_Shop_Flatlays_Core_092225.jpg');
  $('.card__media .product-link-8747387027608 img.non-flip, .card__media .product-link-8747387027608 img.large-flip-card-front').attr('src', 'https://cdn.shopify.com/s/files/1/0608/9955/7528/files/YT_Shop_Flatlays_Core_092225.jpg');
  $('.card__media .product-link-14812521103730 img.non-flip, .card__media .product-link-14812521103730 img.large-flip-card-front, .card__media .product-link-8857988169880 img.non-flip, .card__media .product-link-8857988169880 .large-flip-card-front').attr('srcset', 'https://cdn.shopify.com/s/files/1/0608/9955/7528/files/YT_Shop_Flatlays_Core_092225.jpg');
  $('.card__media .product-link-14812524511602 img.non-flip, .card__media .product-link-14812524511602 img.large-flip-card-front').attr('srcset', 'https://cdn.shopify.com/s/files/1/0608/9955/7528/files/YT_Shop_Flatlays_Deluxe_092225.jpg');
  $('.card__media .product-link-8858010124440 img.non-flip, .card__media .product-link-8858010124440 img.large-flip-card-front').attr('srcset', 'https://cdn.shopify.com/s/files/1/0608/9955/7528/files/YT_Shop_Flatlays_Deluxe_092225.jpg');
  
   $('.card__media .product-link-15018535551346 img.non-flip, .card__media .product-link-15018535551346 img.large-flip-card-front, .card__media .product-link-9070289420440 img.non-flip, .card__media .product-link-9070289420440 img.large-flip-card-front').attr('src', 'https://cdn.shopify.com/s/files/1/0704/7751/2998/files/CS_Favorites_BRS-Kit_Deluxe_New.jpg');
   $('.card__media .product-link-15018535551346 img.non-flip, .card__media .product-link-15018535551346 img.large-flip-card-front, .card__media .product-link-9070289420440 img.non-flip, .card__media .product-link-9070289420440 img.large-flip-card-front').attr('srcset', 'https://cdn.shopify.com/s/files/1/0704/7751/2998/files/CS_Favorites_BRS-Kit_Deluxe_New.jpg');
   $('.card__media .product-link-15018493378930 img.non-flip, .card__media .product-link-15018493378930 img.large-flip-card-front, .card__media .product-link-9070259601560 img.non-flip, .card__media .product-link-9070259601560 img.large-flip-card-front').attr('src', 'https://tbf-stg.myshopify.com/cdn/shop/files/cs-favorites-brs-kit-Core_New.jpg');
   $('.card__media .product-link-15018493378930 img.non-flip, .card__media .product-link-15018493378930 img.large-flip-card-front, .card__media .product-link-9070259601560 img.non-flip, .card__media .product-link-9070259601560 img.large-flip-card-front').attr('srcset', 'https://tbf-stg.myshopify.com/cdn/shop/files/cs-favorites-brs-kit-Core_New.jpg');

  hideExfoliantOptions();

  if(document.body.classList.contains('customer-member')) {
    if($(".pdp-skin-revitalizing-tool").length){
      $(".sticky-footer-price").html($(".pdp-price-span").html());
    }
  }
  if($(".pdp-page").hasClass("pdp-antioxidant-wellness-beauty-blend-trynow")){
    $(".section-header").addClass("pdp-antioxidant-wellness-beauty-blend-trynow");
  }
  if($(".pdp-page").hasClass("pdp-antioxidant-wellness-beauty-blend-member-exclusive")){
    $(".section-header").addClass("pdp-antioxidant-wellness-beauty-blend-member-exclusive");
  }

  if (window.location.href.indexOf("/vip-youthful-essence") > -1 ||
    window.location.href.indexOf("/products/rejuvenate-restore-kit-2") > -1 ||
    window.location.href.indexOf("/products/antioxidant-wellness-beauty-blend-2") > -1 ||
    window.location.href.indexOf("/products/radiance-renewing-collagen-peptides-1") > -1 ||
    window.location.href.indexOf("/products/mind-mood-adaptogen-boost-2") > -1 ||
    window.location.href.indexOf("/products/gut-balancing-probiotic-support-2") > -1) {
    $(".section-header").addClass("vip-youthful-essence-header");
    $(".customer-guest").addClass("vip-youthful-header");
    $(".slider-announcement-bar-wrapper a").html("<strong>Exclusive VIP Youthful Essence Offer!</strong>").removeAttr("href").attr("role", "text");
    if ($('.slider-announcement-bar-wrap').hasClass('slick-initialized')) {
      var $slider = $('.slider-announcement-bar-wrap');
      $slider.slick('unslick');
      $slider.children().last().remove();
    }
    //$(".core-common-billboard .landingpage.block-cta").text("TRY YOUTHFUL ESSENCE TODAY");
    $(".core-common-billboard .block-cta").attr("href", "/products/rejuvenate-restore-kit-2");
  }
  
});

(function(){
  // ------------ CONFIG ------------
  const LIMITED_HANDLE = "antioxidant-wellness-beauty-blend-trynow";
  const ERROR_TEXT = "Your shopping cart already contains the maximum allowed quantity of this product.";
  const isLimitedPage = location.pathname.replace(/\/+$/,'').split('/').pop() === LIMITED_HANDLE;

  // ------------ STATE ------------
  const limitState = { cartItems: [], cartFetched: false };
  let lastSelectedOption = null; // "subscription" | "onetime"

  // ------------ DOM HELPERS ------------
  const $ = (s, r=document) => r.querySelector(s);
  const getForm         = () => $('form.add-to-cart-form');
  const getAddBtn       = () => getForm()?.querySelector('#addToCartPdp');
  const getLabelEl      = () => getAddBtn()?.querySelector('.add_to_cart_label');
  const getFooterBtn    = () => document.querySelector('#footer-cta-pdp');
  const getFooterLbl    = () => getFooterBtn()?.querySelector('.add_to_cart_label');
  const getPaymentWrap  = () => document.querySelector('[data-shopify="payment-button"]');
  const getVariantId    = () => Number(($('input[name="id"]', getForm()||document) || {}).value || 0);
  const getSelectedOption = () => {
    const checked = document.querySelector('input[name="purchaseOption"]:checked');
    if (checked) return checked.value;
    // Fallback to Recharge's active class on first paint
    if (document.querySelector('.rc-radio.rc-radio--active.subscription-radio')) return 'subscription';
    return 'onetime';
  };

  // ------------ ERROR UI ------------
  function ensureErrorEl(anchorEl, id) {
  if (!anchorEl) return null;
  let el = document.getElementById(id);
  if (!el) {
    el = document.createElement('div');
    el.id = id;
    el.className = 'error-message d-none';
    el.setAttribute('role', 'alert');
    // place right below the button
    anchorEl.parentElement && anchorEl.parentElement.appendChild(el);
  }
  return el;
}
  function showErrors(msg) {
  const mainErr = ensureErrorEl(getAddBtn(), 'pdp-error-main');
  if (mainErr) {
    mainErr.textContent = msg || ERROR_TEXT;
    mainErr.classList.remove('d-none');
  }
}

// Hide error ONLY under main PDP button
function hideErrors() {
  const mainErr = document.getElementById('pdp-error-main');
  if (mainErr) mainErr.classList.add('d-none');
}

  // ------------ ENABLE/DISABLE + LABELS ------------
  function setDisabled(state, optForLabel) {
    const mode = optForLabel || lastSelectedOption || getSelectedOption(); // "subscription" | "onetime"

    // Buttons
    [getAddBtn(), getFooterBtn()].forEach(btn => {
      if (!btn) return;
      btn.disabled = !!state;
      btn.classList.toggle('disabled', !!state);
    });

    // Labels (never "Already in Cart")
    [getLabelEl(), getFooterLbl()].forEach(lbl => {
      if (!lbl) return;
      lbl.textContent = (mode === 'subscription') ? 'Subscribe' : 'Add to cart';
    });

    // Accelerated checkout safety
    const pay = getPaymentWrap();
    if (pay) {
      pay.setAttribute('aria-disabled', state ? 'true' : 'false');
      pay.style.pointerEvents = state ? 'none' : '';
      pay.style.opacity = state ? '0.5' : '';
    }

    // Error banner
    if (state) showErrors(ERROR_TEXT);
    else hideErrors();
  }

  // ------------ CART HELPERS ------------
  async function fetchCartOnce() {
    if (limitState.cartFetched) return;
    try {
      const res = await fetch('/cart.js', { credentials: 'same-origin' });
      const cart = await res.json();
      limitState.cartItems = cart.items || [];
    } catch (_) {
      limitState.cartItems = [];
    } finally {
      limitState.cartFetched = true;
    }
  }
  function isProductInCartAnyOption() {
    const vId = getVariantId();
    return limitState.cartItems.some(item =>
      (item.handle === LIMITED_HANDLE) || (vId && item.variant_id === vId)
    );
  }

  // ------------ SYNC FUNCTION ------------
  function updateButtonState(forceOption) {
    if (!isLimitedPage || !limitState.cartFetched) return;

    const opt = forceOption || getSelectedOption();
    lastSelectedOption = opt;

    // GLOBAL LOCK: if product exists in cart in ANY mode → disable both
    const anyExists = isProductInCartAnyOption();
    setDisabled(anyExists, opt);
  }

  // ------------ SUBMIT GUARD (GLOBAL) ------------
  document.addEventListener('submit', (e) => {
    const f = getForm();
    if (f && e.target === f && isLimitedPage) {
      if (isProductInCartAnyOption()) {
        e.preventDefault();
        e.stopImmediatePropagation?.();
        setDisabled(true, lastSelectedOption || getSelectedOption());
      }
    }
  }, true);

  // ------------ RADIO → INSTANT UPDATE (FIRST-CLICK SAFE) ------------
  document.addEventListener('change', (e) => {
    if (e.target && e.target.name === 'purchaseOption') {
      lastSelectedOption = e.target.value;           // "subscription" | "onetime"
      updateButtonState(e.target.value);
    }
  });
  // Some themes click label first; handle that too
  document.addEventListener('click', (e) => {
    const input = e.target.closest('label')?.querySelector('input[name="purchaseOption"]');
    if (input) {
      lastSelectedOption = input.value;
      updateButtonState(input.value);
    }
  }, { passive: true });

  // ------------ NETWORK TAPS (fetch + XHR) ------------
  const isAddURL = (url) => /\/cart\/(add|add\.js)(\?|$)/.test(String(url));

  if (!window.__pdpFetchTap) {
    const _f = window.fetch;
    window.fetch = async function(i, init){
      const url = typeof i === 'string' ? i : (i && i.url) || '';
      const res = await _f.apply(this, arguments);
      if (isLimitedPage && isAddURL(url) && res.ok) {
        // Immediately lock both buttons; keep label based on current/last option
        setDisabled(true, lastSelectedOption || getSelectedOption());
        // Refresh cart in background; state will remain disabled due to global lock
        limitState.cartFetched = false;
        fetchCartOnce().then(() => updateButtonState(lastSelectedOption));
      }
      return res;
    };
    window.__pdpFetchTap = true;
  }

  if (!window.__pdpXhrTap) {
    const o = XMLHttpRequest.prototype.open, s = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function(m,u){ this.__isAdd = isAddURL(u); return o.apply(this, arguments); };
    XMLHttpRequest.prototype.send = function(){
      if (this.__isAdd) this.addEventListener('load', () => {
        if (isLimitedPage && this.status >= 200 && this.status < 300) {
          setDisabled(true, lastSelectedOption || getSelectedOption());
          limitState.cartFetched = false;
          fetchCartOnce().then(() => updateButtonState(lastSelectedOption));
        }
      });
      return s.apply(this, arguments);
    };
    window.__pdpXhrTap = true;
  }

  // Listen for common slide-cart events and body class changes to re-check
  const recheckAfterCartUI = () => { limitState.cartFetched = false; fetchCartOnce().then(() => updateButtonState(lastSelectedOption)); };
  document.addEventListener('cart:updated', recheckAfterCartUI);
  document.addEventListener('cart:closed', recheckAfterCartUI);
  document.addEventListener('ajaxCart.afterUpdate', recheckAfterCartUI);
  const body = document.body;
  const mo = new MutationObserver(() => {
    // When cart closes (cart-open removed), re-evaluate
    if (!body.classList.contains('cart-open')) recheckAfterCartUI();
  });
  mo.observe(body, { attributes: true, attributeFilter: ['class'] });

  // ------------ INIT ------------
  if (isLimitedPage) {
    lastSelectedOption = getSelectedOption();
    // Disable while checking (label still shows Subscribe/Add to cart)
    setDisabled(true, lastSelectedOption);
    // Small delay lets Recharge mark the default radio on first paint
    setTimeout(async () => {
      await fetchCartOnce();
      updateButtonState(lastSelectedOption);
    }, 50);
  }
})();


if ($('.sas-page-kits-section').length > 0 || $('.common-preupsell-top-section').length > 0) {
  document.addEventListener("DOMContentLoaded", function () {
    if (typeof klaviyo !== 'undefined' && typeof klaviyo.push === 'function') {  
      function cleanImageUrl(raw) {
        if (!raw) return "";
        return raw
          .trim().replace(/\s+/g, "").replace(/^\/\//, "https://"); 
      }
      function updateKitData(event, controlEl) {         
        const clickedButton = controlEl || event?.target;
        const fullUrl = window.location.href;
        const urlObj = new URL(fullUrl);
        const cleanUrl = urlObj.origin + urlObj.pathname;
        const pageName = document.title || "Unknown Page";
        const queryParams = {};
        for (const [key, value] of urlObj.searchParams.entries()) {
          queryParams[key] = value;
        }
        let kitName = "Default Kit Name";
        let kitImageUrl = "https://tbf-stg.myshopify.com/cdn/shop/files/thebodyfirm-tm-image.png";
        if (fullUrl.includes('prepu') || fullUrl.includes('preupsell')) {
          const variantTitleElement = document.querySelector('.selected-cart-product-title');
          const variantImageElement = document.querySelector('.selected-cart-product-image');
          const titleValue = variantTitleElement?.value?.trim();
          const imageValue = cleanImageUrl(variantImageElement?.value);
          if (titleValue) kitName = titleValue;
          if (imageValue) kitImageUrl = imageValue;
        }
        const selectedKit = document.querySelector('.sas-page-kit.active.selected');
        if (selectedKit) {
          const variantTitleElement = selectedKit.querySelector('.selected-variant-title');
          const variantImageElement = selectedKit.querySelector('.selected-variant-image');
          if (variantTitleElement) kitName = variantTitleElement.value || kitName;
          if (variantImageElement) {
            const rawImageUrl = cleanImageUrl(variantImageElement.value);
            if (rawImageUrl) kitImageUrl = rawImageUrl;
          }
        } else if (clickedButton) {
          const buttonClasses = clickedButton.classList;
          const isNoThanks = buttonClasses.contains('nothanks-cta') || buttonClasses.contains('btn-no-upgrade');

          if (isNoThanks) {
            const titleValue = document.querySelector('.selected-cart-product-title')?.value?.trim();
            const imageValue = cleanImageUrl(document.querySelector('.selected-cart-product-image')?.value);
            if (titleValue) kitName = titleValue;
            if (imageValue) kitImageUrl = imageValue;
          } else {
            const variantTitleElement = document.querySelector('.selected-variant-title');
            const variantImageElement = document.querySelector('.selected-variant-image');

            if (variantTitleElement) {
              kitName = variantTitleElement.value || kitName;
            } else {
              kitName = clickedButton.textContent.trim() || kitName;
            }

            if (variantImageElement) {
              const rawImageUrl = cleanImageUrl(variantImageElement.value);
              if (rawImageUrl) kitImageUrl = rawImageUrl;
            }
          }
        }
        const klaviyoData = {
          CleanURL: cleanUrl,
          PageName: pageName,
          KitName: kitName,
          KitImageURL: kitImageUrl,
          ...queryParams
        }; 
        klaviyo.push(['track', 'Page View', klaviyoData]); 
      }
      setTimeout(() => {
        updateKitData(); // Run on load
      }, 900);
      document.body.addEventListener('click', function (event) {
        const clickedButton = event.target;
        const clickEl =
          clickedButton && typeof clickedButton.closest === 'function'
            ? clickedButton.closest(
                'a.new-layout-cta, button.new-layout-cta, a.sas-kit-cta, button.sas-kit-cta, a.preupsell-cta, button.preupsell-cta, a.nothanks-cta, button.nothanks-cta, .btn-upgrade, .btn-no-upgrade, a.extra-sas-checkout-button, button.extra-sas-checkout-button'
              ) || clickedButton
            : clickedButton;
        const classCombinations = [
          ['new-layout-cta'],
          ['sas-kit-cta'],
          ['preupsell-cta'],
          ['nothanks-cta'],
          ['btn-upgrade'],
          ['btn-no-upgrade'],
          ['extra-sas-checkout-button']
        ];
        const matches = classCombinations.some(classList =>
          classList.every(className => clickEl.classList && clickEl.classList.contains(className))
        );
        if (matches) {
          updateKitData(event, clickEl);
        }
      });
    } else {
      console.warn("⚠️Klaviyo not detected. Script will not run.");
    }
  }); 
}

$(document).ready(function() {
  if (window.location.href.indexOf("/vip-youthful-essence") > -1) {
  var customDiv = `
    <div class="vip-seller-column">
      <div class="vip-content-wrapper">             
      </div>    
      <div class="vip-bottom-section">
          <p class="vip-product-tag">Nourish. Thrive. Energize</p>    
          <div class="vip-product-button">          
            <a href="/products/rejuvenate-restore-kit-2" class="vip-cta">GET IT NOW</a>
          </div>  
      </div>
    </div>
  `;
  
   $(".grid__item.kit-product.property-kit").eq(1).after(customDiv);
  };

  // custom code
  // setTimeout(function () {
  //   if ($('body').hasClass('cancel-subscription-selected')) {
  //     $(".rc-widget .subscription-radio input").trigger("click");
  //   }
  //   if($(".membership-radio").length){
  //     $('.rc-radio.membership-radio input').trigger('click');
  //   }
  // }, 5000);
  
});
$(window).on('load', function() {
  setTimeout(function () {
    if ($('body').hasClass('active-subscription-selected')) {
      if ($('.subscription-radio').hasClass('ce-rc-active')) {
          $('#footer-cta-pdp').text('ADD TO KIT');
      }
    }
    if ($('body').hasClass('cancel-subscription-selected')) {
      if ($('.subscription-radio').hasClass('ce-rc-active')) {
        $('#addToCartPdp').text('SUBSCRIBE');
        $('#footer-cta-pdp .add_to_cart_label').text('SUBSCRIBE');
      }
    }
  }, 1000);
});

function enablePreupsellCTA() {
  const buttons = document.querySelectorAll(".preupsell-cta");

  buttons.forEach(function (button) {
    button.removeAttribute("disabled");
    button.disabled = false;
  });
}

document.addEventListener("DOMContentLoaded", enablePreupsellCTA);
window.addEventListener("load", enablePreupsellCTA);

const observer = new MutationObserver(function () {
  enablePreupsellCTA();
});

observer.observe(document.body, {
  childList: true,
  subtree: true,
  attributes: true,
  attributeFilter: ["disabled"]
});

// lp-sp12 campaign updates
if ($('body').hasClass('lp-specialoffer12-campaign')) {
  $(document).on('click', '.billboard-default .block-cta', function (e) {
    e.preventDefault();

    $('html, body').animate({
      scrollTop: $('#kitproduct-showcase').offset().top
    }, 800);
  });
}